const LIVE_ORDER_EMAILS = [
  "ashish.gupta@shiprocket.com",
  "saahil.goel@shiprocket.com",
  "prabhat.singh@shiprocket.com",
  "ajit.verma@shiprocket.com",
  "prince.goel@shiprocket.com",
  "shiprocket.tv@gmail.com",
  "kumar.mohit@shiprocket.com"
];

export const isLiveOrderEmail = (email?: string | null): boolean => {
  if (!email) return false;
  return LIVE_ORDER_EMAILS.includes(email.toLowerCase());
};

export const getStoredUserEmail = (): string | null => {
  if (typeof window === "undefined") return null;
  const stored = localStorage.getItem("user");
  if (!stored) return null;
  try {
    const parsed = JSON.parse(stored);
    return typeof parsed?.email === "string" ? parsed.email : null;
  } catch {
    return null;
  }
};
